import axios from './api'
const promotionServer = {
    getPromotionPageList(params) {
        return axios.post(`/org/promotionPlan/pageList`, params).then((res) => {
            return res.data
        })
    },

    getPlanDetails(params) {
        return axios.get(`/org/promotionPlan/load`, { params: params }).then((res) => {
            return res.data
        })
    },

    addPromotionPlan(params) {
        return axios.post(`/org/promotionPlan/saveOrUpdate`, params).then((res) => {
            return res.data
        })
    },

    payPlanBudget(params) {
        return axios.post(`/org/promotionPlan/pay`, params).then((res) => {
            return res.data
        })
    },
}
export default promotionServer


// WEBPACK FOOTER //
// ./src/api/promotion.js